<div class="block editorDisplayBanner">
  <div class="editorDisplaybannerText border-right pr-10px">
    <div class="hblock"><strong>Symbol</strong></div>
    <div class="hblock" style="white-space: nowrap"><strong>{{currentOrderData?.securitySymbol}}</strong></div>
    @if (isSpreadOrder) {
      <div class="hblock" style="white-space: nowrap"><strong>{{currentOrderData?.swapExchangeSymbol}}</strong></div>
    }
  </div>
  <div class="editorDisplayBannerMiddle">
    <div class="editorDisplaybannerText">
      <div class="hblock"><strong>Last trade</strong></div>

      <div class="hblock">{{(bidAndAskPrices?.lastPrice) | number : '1.2-2'}}</div>
      @if (bidAndAskPrices?.lastSize != null) {
        <div class="hblock"><strong>Last size</strong></div>
        <div class="hblock">{{ bidAndAskPrices?.lastSize}}<span class="mpid-tooltip-link" calltoaction [calltoactionTemplate]="tradeOrderLastIdToolTipTemplateRef" [calltoactionUsesHover]="true"><sup>{{bidAndAskPrices?.lastId || ''}}</sup></span></div>
      }

      @if (isSpreadOrder) {
        <div class="hblock">{{(swapBidAndAskPrices?.lastPrice) | number : '1.2-2'}}</div>
      }
      @if (swapBidAndAskPrices?.lastSize != null) {
        <div class="hblock"><strong>Last size</strong></div>
        @if (isSpreadOrder) {
          <div>{{ swapBidAndAskPrices?.lastSize}}<span class="mpid-tooltip-link" calltoaction [calltoactionTemplate]="tradeOrderLastIdToolTipTemplateRef" [calltoactionUsesHover]="true"><sup>{{swapBidAndAskPrices?.lastId || ''}}</sup></span></div>
        }
      }
    </div>
    <div class="editorDisplaybannerText">
      <div class="hblock"><strong>Bid</strong></div>

      <div class="hblock">{{ bidAndAskPrices?.bid | number : '1.2-2'}}</div>
      @if (bidAndAskPrices?.bidSize != null) {
        <div class="hblock"><strong>Bid size</strong></div>
        <div class="hblock">{{(bidAndAskPrices?.bidSize) | number : '1.0-0'}}<span class="mpid-tooltip-link" calltoaction [calltoactionTemplate]="tradeOrderBidIdToolTipTemplateRef" [calltoactionUsesHover]="true"><sup>{{bidAndAskPrices?.bidId || ''}}</sup></span></div>
      }

      @if (isSpreadOrder) {
        <div class="hblock">{{ swapBidAndAskPrices?.bid | number : '1.2-2'}}</div>
      }
      @if (swapBidAndAskPrices?.bidSize != null) {
        <div class="hblock"><strong>Bid size</strong></div>
        @if (isSpreadOrder) {
          <div>{{(swapBidAndAskPrices?.bidSize) | number : '1.0-0'}}<span class="mpid-tooltip-link" calltoaction [calltoactionTemplate]="tradeOrderBidIdToolTipTemplateRef" [calltoactionUsesHover]="true"><sup>{{swapBidAndAskPrices?.bidId || ''}}</sup></span></div>
        }
      }
    </div>
    <div class="editorDisplaybannerText">
      <div class="hblock"><strong>Ask</strong></div>

      <div class="hblock">{{ bidAndAskPrices?.ask | number : '1.2-2'}}</div>
      @if (bidAndAskPrices?.askSize != null) {
        <div class="hblock"><strong>Ask size</strong></div>
        <div class="hblock">{{(bidAndAskPrices?.askSize) | number : '1.0-0'}}<span class="mpid-tooltip-link" calltoaction [calltoactionTemplate]="tradeOrderAskIdToolTipTemplateRef" [calltoactionUsesHover]="true"><sup>{{bidAndAskPrices?.bidId || ''}}</sup></span></div>
      }

      @if (isSpreadOrder) {
        <div class="hblock">{{ swapBidAndAskPrices?.ask | number : '1.2-2'}}</div>
      }
      @if (swapBidAndAskPrices?.askSize != null) {
        <div class="hblock"><strong>Ask size</strong></div>
        @if (isSpreadOrder) {
          <div>{{(swapBidAndAskPrices?.askSize) | number : '1.0-0'}}<span class="mpid-tooltip-link" calltoaction [calltoactionTemplate]="tradeOrderAskIdToolTipTemplateRef" [calltoactionUsesHover]="true"><sup>{{swapBidAndAskPrices?.bidId || ''}}</sup></span></div>
        }
      }
    </div>
    <div class="editorDisplaybannerText">
      <div class="hblock"><strong>Midpoint</strong></div>
      <div class="hblock">{{ bidAndAskPrices?.midpoint | number : '1.2-2'}}</div>
      @if (isSpreadOrder) {
        <div>{{ swapBidAndAskPrices?.midpoint | number : '1.2-2'}}</div>
      }
    </div>
    @if (!isOption) {
      <div class="editorDisplaybannerText">
        <div class="hblock"><strong>Volume</strong><span style="margin-bottom: 0;" class="infoIcon" calltoaction [calltoactionTemplate]="tradeOrderVolumeToolTipTemplateRef" [calltoactionUsesHover]="true"></span></div>
        <div class="hblock">{{ bidAndAskPrices?.totalVolume }}</div>
        <div class="hblock"><strong>Avg Volume</strong><span id="tradeOrderToolTipIcon" style="margin-bottom: 0;" class="infoIcon" calltoaction [calltoactionTemplate]="tradeOrderAvgVolumeToolTipTemplateRef" [calltoactionUsesHover]="true"></span></div>
        <div class="hblock">{{ currentOrderData?.avgDailyTradeVol }}</div>
      </div>
    }
  </div>
  <div class="editorDisplaybannerText border-left mr-20px">
    <div class="hblock ml-10px"><strong>Rebal&nbsp;ID</strong></div>
    <div class="rebal-id ml-10px">{{ rebalanceIDDisplayValue }}</div>
  </div>
  <div class="editorDisplaybannerText">
    <div class="hblock"><strong>Portfolio</strong></div>
    <div class="portfolio">{{ currentOrderData?.portfolioName }}</div>
  </div>
</div>
<ng-template #tradeOrderVolumeToolTipTemplateRef>
  Consolidated Daily Volume
</ng-template>
<ng-template #tradeOrderAvgVolumeToolTipTemplateRef>
  10 Day Average Volume
</ng-template>
<ng-template #tradeOrderBidIdToolTipTemplateRef>
  {{bidAndAskPrices?.bidIdToolTip || 'test bid tip'}}
</ng-template>
<ng-template #tradeOrderLastIdToolTipTemplateRef>
  {{bidAndAskPrices?.lastIdToolTip || 'test Last tip'}}
</ng-template>
<ng-template #tradeOrderAskIdToolTipTemplateRef>
  {{bidAndAskPrices?.askIdToolTip || 'test bid tip'}}
</ng-template>